import { IEnvironment } from "./interface/ienvironment";

const apiHost = 'appyhealthservicesv2-dev.azurewebsites.net';
const apiVersion = 'v2/'
const apiEndpoint = `https://${apiHost}/api/${apiVersion}`;

export const environment: IEnvironment = {
  production: false,
  enableDebugTools: true,
  logLevel: 'debug',
  apiEndpoint,
  apiHost,
  androidUrl: 'https://play.google.com/store/apps/details?id=appy.health.mobile&amp;hl=en',
  appleUrl: 'https://apps.apple.com/us/app/appy-health/id1464947017',
  handleHealthUrl: 'https://api.handlhealth.com/beta/price/service-cost-estimator',
  handleHealthKey: 'sjbzUXSBL89lPcGaszdnQqXJnZKhXo7azL9AMiQj',
};
